// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { OrgType } from "../archive/org-type";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * GET /orgs/light — minimal org info for dropdowns/selectors.
 * Matches Go: models.OrganizationLight { Name, ID, Type }
 */
export class OrgLight implements flatbuffers.IUnpackableObject<OrgLightT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): OrgLight {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsOrgLight(bb: flatbuffers.ByteBuffer, obj?: OrgLight): OrgLight {
    return (obj || new OrgLight()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsOrgLight(bb: flatbuffers.ByteBuffer, obj?: OrgLight): OrgLight {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new OrgLight()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  type(): OrgType {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : OrgType.MASTER;
  }

  static startOrgLight(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, nameOffset, 0);
  }

  static addType(builder: flatbuffers.Builder, type: OrgType) {
    builder.addFieldInt8(2, type, OrgType.MASTER);
  }

  static endOrgLight(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // name
    return offset;
  }

  static createOrgLight(
    builder: flatbuffers.Builder,
    idOffset: flatbuffers.Offset,
    nameOffset: flatbuffers.Offset,
    type: OrgType,
  ): flatbuffers.Offset {
    OrgLight.startOrgLight(builder);
    OrgLight.addId(builder, idOffset);
    OrgLight.addName(builder, nameOffset);
    OrgLight.addType(builder, type);
    return OrgLight.endOrgLight(builder);
  }

  unpack(): OrgLightT {
    return new OrgLightT(this.id() !== null ? this.id()!.unpack() : null, this.name(), this.type());
  }

  unpackTo(_o: OrgLightT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.name = this.name();
    _o.type = this.type();
  }

  unpackFields(...fields: string[]): OrgLightT {
    const t = new OrgLightT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("type")) {
      t.type = this.type();
    }
    return t;
  }
}

export class OrgLightT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public type: OrgType = OrgType.MASTER,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;

    return OrgLight.createOrgLight(builder, id, name, this.type);
  }

  clone(): OrgLightT {
    const obj = new OrgLightT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.name = this.name;
    obj.type = this.type;
    return obj;
  }

  equals(other: OrgLightT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.name !== other.name) return false;
    if (this.type !== other.type) return false;
    return true;
  }
}

export function verifyOrgLight(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "name");
    verifier.checkScalarField(tablePos, 8, 1);
  } finally {
    verifier.popDepth();
  }
}
